const allImages = {
  'iPhone 18 Pro': [
    ['Burgundy', require('../assets/images/thumbnails/iphone18pro-burgundy.png')],
    ['Black', require('../assets/images/thumbnails/iphone18pro-black.png')],
    ['Glacier', require('../assets/images/thumbnails/iphone18pro-glacier.png')],
    ['Silver', require('../assets/images/thumbnails/iphone18pro-silver.png')]
  ],
  'iPhone 18 Pro Max': [
    ['Burgundy', require('../assets/images/thumbnails/iphone18promax-burgundy.png')],
    ['Black', require('../assets/images/thumbnails/iphone18promax-black.png')],
    ['Glacier', require('../assets/images/thumbnails/iphone18promax-glacier.png')],
    ['Silver', require('../assets/images/thumbnails/iphone18promax-silver.png')]
  ],
  'iPhone Duo': [
    ['Star White', require('../assets/images/thumbnails/iphoneduo-star-white.png')],
    ['Night Sky', require('../assets/images/thumbnails/iphoneduo-night-sky.png')]
  ]
};

function createDeviceImageConfig(deviceName) {
  const allDeviceImages = allImages[deviceName];
  return allDeviceImages.map(([colour, src]) => ({
    name: deviceName,
    colour,
    src
  }));
}

const deviceRanking = [
  {
    name: 'iPhone 18 Pro Max',
    colours: ['Burgundy', 'Glacier', 'Silver', 'Black'],
    sizes: ['256GB', '512GB', '1TB', '2TB']
  },
  {
    name: 'iPhone 18 Pro',
    colours: ['Burgundy', 'Glacier', 'Silver', 'Black'],
    sizes: ['256GB', '512GB', '1TB', '2TB']
  }
];

const deviceDuoRanking = [
  {
    name: 'iPhone Duo',
    colours: ['Star White', 'Night Sky'],
    sizes: ['256GB', '512GB', '1TB', '2TB']
  }
];

export const devicePreSelectDuoRanking = {
  models: deviceDuoRanking
};

export const productSelectionRanking = {
  models: deviceRanking
};

// Presales-specific ranking for iPhone tests
const presalesRanking = [
  {
    name: 'iPhone 17',
    colours: ['Sage', 'White', 'Lavender', 'Mist Blue', 'Black'],
    sizes: ['512GB', '256GB']
  },
  {
    name: 'iPhone 17 Pro Max',
    colours: ['Deep Blue', 'Cosmic Orange', 'Silver'],
    sizes: ['512GB', '1TB', '2TB', '256GB']
  },
  {
    name: 'iPhone 17 Pro',
    colours: ['Cosmic Orange', 'Deep Blue', 'Silver'],
    sizes: ['256GB', '512GB', '1TB']
  },
  {
    name: 'iPhone Air',
    colours: ['Cloud White', 'Light Gold', 'Sky Blue', 'Space Black'],
    sizes: ['1TB', '256GB', '512GB']
  }
];

export const productSelectionRankingiphone17presales = {
  models: presalesRanking
};


export const devices = {
  iphone18roi: {
    name: 'iPhone 18',
    description: 'iPhone 18',
    devices: {
      'iPhone 18 Pro Max': require('../assets/images/thumbnails/iphone18promax-burgundy.png'),
      'iPhone 18 Pro': require('../assets/images/thumbnails/iphone18pro-burgundy.png')
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone 18 Pro Max'),
      ...createDeviceImageConfig('iPhone 18 Pro')
    ],
    banner: require('../assets/images/banners/banner_iphone18_mass_800x400.png'),
    productSelectionRanking,
    presale: false,
    plainRegistrationOnly: true
  },
  iphoneduoroi: {
    name: 'iPhone Duo',
    description: 'iPhone Duo',
    devices: {
      'iPhone Duo': require('../assets/images/thumbnails/iphoneduo-star-white.png'),
    },
    // List of all images for all the devices and their colors
    images: [
      ...createDeviceImageConfig('iPhone Duo')
    ],
    banner: require('../assets/images/banners/banner_iphone18_mass_800x400.png'),
    productSelectionRanking: devicePreSelectDuoRanking,
    presale: false,
    plainRegistrationOnly: true
  },
  default: {
    banner: require('../assets/images/banners/banner_iphone18_mass_800x400.png')
  },
  allImages: []
};

export const defaultDevice = Object.keys(devices)[0];
